'use client'

import { FormControl, FormField, FormItem, FormMessage, Textarea } from '@repo/ui'
import { Control } from 'react-hook-form'

interface Props {
  control: Control<{ notes: string }>
}

export const Notes = ({ control }: Props) => {
  return (
    <FormField
      control={control}
      name={'notes'}
      render={({ field }) => (
        <FormItem className={'w-full'}>
          <FormControl>
            <Textarea placeholder={'Additional information'} rows={6} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
